__turbopack_context__.v({
  "centerRadio": "VgAFla_centerRadio",
  "mantine-Group-root": "VgAFla_mantine-Group-root",
  "mantine-Radio-inner": "VgAFla_mantine-Radio-inner",
  "mantine-Radio-label": "VgAFla_mantine-Radio-label",
  "mantine-Radio-root": "VgAFla_mantine-Radio-root",
  "radioCard": "VgAFla_radioCard",
});
